/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots8VIcon20Regular = forwardRef('UiMenuDots8VIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.5 5.003a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" }),
        React.createElement("path", { d: "M7.5 9.335a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" }),
        React.createElement("path", { d: "M9 12.168a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" }),
        React.createElement("path", { d: "M7.5 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" }),
        React.createElement("path", { d: "M14 3.503a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" }),
        React.createElement("path", { d: "M12.5 9.335a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" }),
        React.createElement("path", { d: "M14 12.168a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" }),
        React.createElement("path", { d: "M12.5 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" })));
});
